// extracted by mini-css-extract-plugin
export default {"scope":"h86r5","scope--is-disabled":"sGN13","value":"sGRz2","actions":"F2ToG"};